<template>
	<div class="bg-reen-200">

		<div class="container mx-auto px-5">

			<div id="mode-switch" class="bg-background-300 h-16 rounded-lg flex flex-row items-center justify-around mt-5">
				<span :class="{'bg-background-200': buttons.toogle }" class="block font-semibold w-40 h-10 flex items-center justify-center rounded-lg" @click="toggle('rgb')" >RGB</span>
				<span :class="{'bg-background-200': !buttons.toogle }" class="block w-40 font-semibold h-10 flex items-center justify-center rounded-lg" @click="toggle('rgbw')">RGBW</span>
			</div>

			<div class="my-12 block"></div>

			<div id="input-universum" class="bg-background-300 h-16 rounded-lg flex flex-row items-center justify-around mt-5">
				<span class="w-40 h-10 font-semibold block flex items-center justify-center">Universum</span>
				<input type="number" pattern="\d*"  step="any" v-model="universum" class="w-40 h-10 text-center bg-background-200 rounded-lg border-transparent outline-none" @input="calculateUniverse()" >
			</div>

			<div id="input-channel" class="bg-background-300 h-16 rounded-lg flex flex-row items-center justify-around mt-5">
				<span class="w-40 h-10 font-semibold block flex items-center justify-center">Channel</span>
				<input type="number" pattern="\d*"  step="any" v-model="channel" class="w-40 h-10 text-center bg-background-200 rounded-lg border-transparent outline-none" @input="calculateChannel()">
			</div>

			<div id="input-pixel" class="bg-background-300 h-16 rounded-lg flex flex-row items-center justify-around mt-5">
				<span class="w-40 h-10 font-semibold block flex items-center justify-center">Pixel</span>
				<input type="number" pattern="\d*"  step="any" v-model="pixel" class="w-40 h-10 text-center bg-background-200 rounded-lg border-transparent outline-none" @input="calculatePixel()">
			</div>

		</div>
	</div>
</template>

<script>
export default {
	data() {
		return {
			universum: 2,
			channel: 0,
			pixel: 8,
			buttons: {
				toogle: true,
				current: 'rgb',
				rgb: {
					value: 3
				},
				rgbw: {
					value: 4
				}
			},
			change: {
				lastChangeString: "Pixel",
				fn: {
					Pixel: () => this.calculatePixel(),
					Channel: () => this.calculateChannel(),
					Universe: () => this.calculateUniverse(),
				}
			}
		}
	},
	mounted() {
		this.calculatePixel();
	},
	methods: {
		universumFn: function() { return this.channel / 512 },
		channelFn: function(){ return this.pixel * this.buttons[this.buttons.current].value },
		toggle: function(button) {
			this.buttons.current = button;
			this.buttons.toogle = !this.buttons.toogle;
			this.change.fn[this.change.lastChangeString]()
		},
		calculatePixel: function() {
			this.change.lastChangeString = "Pixel";
			this.channel = this.channelFn(); 
			this.universum = this.universumFn();
		},
		calculateChannel: function() {
			this.change.lastChangeString = "Channel";
			this.pixel = this.channel / this.buttons[this.buttons.current].value;
			this.universum = this.channel / 512;
		},
		calculateUniverse: function() {
			this.change.lastChangeString = "Universe";
			this.channel = 	this.universum * 512;
			this.pixel = (this.channel / this.buttons[this.buttons.current].value);
		}
		
	}
}
</script>